export default "__VITE_ASSET__HJVFsgJO__"